import { render, staticRenderFns } from "./imgU.vue?vue&type=template&id=3761439c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3761439c')) {
      api.createRecord('3761439c', component.options)
    } else {
      api.reload('3761439c', component.options)
    }
    module.hot.accept("./imgU.vue?vue&type=template&id=3761439c", function () {
      api.rerender('3761439c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgU.vue"
export default component.exports